/** Public landing after MSAL logout. Must stay outside MsalGuard or the user is bounced back into login. */
export const SIGN_OUT_PATH = '/sign-out';

/**
 * Routes that supply their own logo header and must therefore suppress the portal header and
 * subheader entirely. /unauthorized has always behaved this way; /closed is built from the same
 * template and belongs with it.
 */
const FULL_PAGE_PATHS = ['/unauthorized', '/closed', SIGN_OUT_PATH];

/**
 * Absolute URI MSAL should return to after logout. Trailing slashes on appUrl would otherwise
 * produce `https://host//sign-out`, which Entra will not treat as the registered redirect.
 * Admin uses workforce Azure AD, which only returns to the registered origin — not /sign-out.
 */
export function signOutRedirectUri({ appUrl, app }: { appUrl: string; app?: string }): string {
  return app === 'admin' ? appUrl : `${appUrl.replace(/\/$/, '')}${SIGN_OUT_PATH}`;
}

/** Wizard routes: they keep the portal header, so sign-out stays reachable, but drop the subheader. */
const WIZARD_PATHS = ['/enrollment', '/enrollment-complete'];

/**
 * NavigationEnd.url carries the query string, so an equality test against '/enrollment' never
 * matches a real enrollment link. That is what silently disabled this in two of the three portals.
 */
function pathOf(url: string): string {
  return url.split('?')[0].split('#')[0];
}

export function isFullPageRoute(url: string): boolean {
  return FULL_PAGE_PATHS.includes(pathOf(url));
}

export function isWizardRoute(url: string): boolean {
  return WIZARD_PATHS.includes(pathOf(url));
}
